/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { UserDataSyncStoreClient } from 'vs/platform/userDataSync/common/userDataSyncStoreService';

export class EditSessionsStoreClient extends UserDataSyncStoreClient {
	_serviceBrand: any;
}
